import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MyDialog from '@/components/MyDialog.vue';
import { chain, range } from 'lodash';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import MySelect from '@/components/MySelect.vue';
const powersModule = namespace('powers');
let CharacterSheetCastingAddPower = class CharacterSheetCastingAddPower extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.levelFilter = 0;
        this.alignmentFilter = [];
        this.range = range;
    }
    created() {
        this.fetchPowers();
    }
    get filteredPowers() {
        return chain(this.powers)
            .filter(({ level, powerType, name, forceAlignment }) => level <= this.maxPowerLevel &&
            (!this.alignmentFilter.length || this.alignmentFilter.includes(forceAlignment)) &&
            powerType === this.castingType)
            .sortBy(({ name, prerequisite }) => {
            if (this.powersSelected.includes(name))
                return 2;
            else if (this.isAlreadyKnown(name))
                return 1;
            else if (this.isDisabled(name, prerequisite))
                return -1;
            else
                return 0;
        })
            .reverse()
            .groupBy('level')
            .value();
    }
    isAlreadyKnown(powerName) {
        return !this.powersSelected.includes(powerName) && this.allForcePowers.includes(powerName);
    }
    isDisabled(powerName, prerequisite) {
        const hasEnforcablePrerequisite = prerequisite && this.isEnforcingForcePrerequisites;
        const isMeetingPrerequisite = !hasEnforcablePrerequisite || this.allForcePowers.some(forcePower => prerequisite === forcePower || prerequisite === forcePower + 's');
        return (this.disabled || !isMeetingPrerequisite || this.isAlreadyKnown(powerName)) && !this.powersSelected.includes(powerName);
    }
    togglePower(powerName) {
        const isSelected = this.powersSelected.includes(powerName);
        const powersWithoutNew = this.powersSelected.filter(power => power !== powerName);
        const powersWithNew = this.powersSelected.concat(powerName);
        this.$emit('updatePowers', isSelected ? powersWithoutNew : powersWithNew);
    }
};
__decorate([
    Prop(Boolean)
], CharacterSheetCastingAddPower.prototype, "icon", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetCastingAddPower.prototype, "disabled", void 0);
__decorate([
    Prop(String)
], CharacterSheetCastingAddPower.prototype, "castingType", void 0);
__decorate([
    Prop(Boolean)
], CharacterSheetCastingAddPower.prototype, "isEnforcingForcePrerequisites", void 0);
__decorate([
    Prop({ default: 9, type: Number })
], CharacterSheetCastingAddPower.prototype, "maxPowerLevel", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCastingAddPower.prototype, "powersSelected", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], CharacterSheetCastingAddPower.prototype, "allForcePowers", void 0);
__decorate([
    powersModule.State
], CharacterSheetCastingAddPower.prototype, "powers", void 0);
__decorate([
    powersModule.Action
], CharacterSheetCastingAddPower.prototype, "fetchPowers", void 0);
CharacterSheetCastingAddPower = __decorate([
    Component({
        components: {
            CharacterSheetExpansionFeatures,
            MyDialog,
            MySelect
        }
    })
], CharacterSheetCastingAddPower);
export default CharacterSheetCastingAddPower;
